import React from 'react';
import { Row, Col } from 'reactstrap';

interface PetsFacility {
  id: string;
  property_id: string;
  facility_id: string;
  facility_type: string;
  facility_name: string;
  facility_value: number;
  createdAt: string;
  updatedAt: string;
  property_facilities: {
    id: string;
    facility_type: string;
    facility_name: string;
    createdAt: string;
    updatedAt: string;
  };
}

interface PetsProps {
  petsFacilities: PetsFacility[];
}

const Pets: React.FC<PetsProps> = ({ petsFacilities }) => {
  if (!petsFacilities || petsFacilities.length === 0) {
    return (
      <div className="rounded p-4 text-center mb-1">
        <span className="text-muted">No Pets Facilities Available</span>
      </div>
    );
  }

  // Split amenities into rows of 3
  const rows = [];
  for (let i = 0; i < petsFacilities.length; i += 3) {
    rows.push(petsFacilities.slice(i, i + 3));
  }

  return (
    <div>
      {rows.map((row, idx) => (
        <Row className="mb-2" key={idx}>
          {row.map((facility, j) => (
            <Col md={4} key={j} className="d-flex align-items-center mb-2">
              <i className="ri-check-line me-2" style={{ fontSize: 20, color: "#555" }}></i>
              <span style={{ fontSize: 15 }}>{facility.facility_name}</span>
            </Col>
          ))}
        </Row>
      ))}
    </div>
  );
};

export default Pets;